import React from "react";
// import styles from "./ForgotPassword.module.scss";
 import styles from "../../Auth/DisForgotPassword/DisForgotPassword.module.scss"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "@/lib/toast";
import { emailRegex } from "@/lib/regex";
import FormControl from "@/components/FormControl/FormControl";
import { useForm, type SubmitHandler } from "react-hook-form";
import { combineClasses, getItem, requiredMessage, setItem } from "@/lib/utils";
import Button from "@/components/Button/Button";
// import BackArrowSVG from "@/assets/svg/LoginPage/BackArrowSVG";

import AuthService from "@/services/api/auth/auth";
import { useRole } from "@/pages/Role/Role";
import DisRoutes from "@/routes/DisRoutes";



interface ForgotPasswordFormValues {
  emailOrMob: string;
}

const ForgotPassword: React.FC = () => {
  const location = useLocation();
  
  const email = location.state?.email || getItem("otpEmail");
  const { role: contextRole } = useRole();
  const { role: paramRole } = useParams<{ role: string }>();
  const role = contextRole || paramRole;
  // const storedEmail = getItem("otpEmail");
  // const email = location.state?.email || storedEmail;   

  const {
    register,
    handleSubmit,
    formState: { isValid, isSubmitting, errors },
  } = useForm<ForgotPasswordFormValues>({
    // defaultValues: { emailOrMob: "" },
    defaultValues:email || "",
    mode: "onTouched",
  });

  const validations = {
    emailOrMob: {
      required: requiredMessage("Email Id/Mobile No"),
     
      validate:(value:string)=>{
        const emailPattern=emailRegex;
        const MobPattern=/^[6-9]\d{9}$/;
        if(emailPattern.test(value)|| MobPattern.test(value)){
          return true;
        }
        return "Enter the Valid Email Id";

      }
     
    },
  };

  const navigate=useNavigate();
  const onSubmit: SubmitHandler<ForgotPasswordFormValues> = async (values:any) => {
    const p = AuthService.DisGenerateLoginOtp(values.emailOrMob)
      .then((res:any) => {
        if(res.status === 200){
          setItem("otpEmail", values.emailOrMob);

         navigate(
          role 
          ? `/${role}/${DisRoutes.publicRoutes?.DIS_OTP_VERIFICATION?.path}` : 
          (DisRoutes.publicRoutes?.DIS_OTP_VERIFICATION?.path??"/"),
          {
            state: {
              email: res?.data?.email
            }
          }
        )
          // navigate("/OTP-verification", { state: { email:values.emailOrMob} });
          return "OTP has been sent"
         
        }else if(res.status === 417 || res.message === "Expectation Failed"){
          toast.error(res.error)
        }
      })
      .catch((err) => {
        throw new Error(err.message || "Something went wrong");
      });

    await toast.promise(p, {
      loading: "Sending OTP...",
      success: (msg) => msg as string,
      error: (err) => err.message,
    });
  };

  return (
    <div className={styles.mainDiv}>
      {/* <Lottie animationData={ErrorGif} style={{ height: "12.5rem" }} /> */}
      {/* <img alt="noimg" src="/FFC-logo.png"/> */}
      <p className={styles.heading}>Forgot Password?</p>
      <p className={styles.subHeading}>
      No Worries, We’ve Got You—Reset Your Password in a Few Steps!
      </p>
      <form
        onSubmit={handleSubmit(onSubmit)}
       
        autoComplete="off"
      >
        <div className={styles.formControls}>
          <FormControl
            name="emailOrMob"
            register={register}
            controlType="input"
            label="Email Id / Mobile No"
            placeholder="Enter Email Id / Mobile No"
            validations={validations.emailOrMob}
            errorMessage={errors?.emailOrMob?.message}
            isRequired={true}
            // defaultValue={email}
          />
        </div>

        <Button
          type="submit"
          className={combineClasses(
            styles.button,styles.forgotPass
          
          )}
          disabled={isSubmitting || !isValid}
        >
          Continue
        </Button>

        <div className={styles.backButton}>
          {/* <BackArrowSVG /> */}

        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;
